module.exports = __webpack_public_path__ + "images/the-heat-7b761d476a216216c8483ecceefba66d.png";